import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import assistantIcon from "../../Assets/images/create-assistant-icon.svg";
import { DefaultChatBot } from "../../Assets/svgs/DefaultChatBot";
import { debounce } from "../../Common/debounce";
import { Loader } from "../../Common/Loader";
import useDebounce from "../../Common/useDebounce";
import useCreateAssistant from "../../Hooks/useCreateAssistant";
import BuyAdditionalAssistantModal from "../../Model/BuyAdditionalAssistantModal";
import { ConfirmModel } from "../../Model/ConfirmModel";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import { getAssistantList } from "../../Redux/Slice/Assistant/AssistantsListSlice";
import { DeleteAssistant } from "../../Redux/Slice/Assistant/DeleteAssistantSlice";
import { duplicateAssistant } from "../../Redux/Slice/Assistant/DuplicateAssistantSlice";
import { getAssistantsCount } from "../../Redux/Slice/Assistant/GetAssistantCountSlice";
import { CreateAssistantPopup } from "./CreateAssistantPopUp";

export const AssitantsList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [assistantPopUp, setPopUp] = useState(false);
  const [assistants, setAssistants] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorModel, setErrorModel] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModel, setSuccessModel] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [confirmModel, setCOnfirmModel] = useState(false);
  const [selectedRow, setselectedRow] = useState(false);
  const [searchText, setSearchText] = useState("");
  const searchQuery = useDebounce(searchText, 500);
  const assistantCountData = useSelector(
    (s) => s?.assistantCount?.assistantCountData
  );
  const isMetaAssistant = location?.pathname == "/meta-assistants";
  const customerId = location.pathname.includes("/assistants/")
    ? location.pathname.split("/")[2]
    : undefined;

  const {
    onClickCreateAssistant,
    buyAdditionalAssistantModal,
    handleCloseBuyAdditionalAssistant,
  } = useCreateAssistant(customerId, setIsLoading);

  // const CreateAssistantPopup = () => {
  //   setPopUp(true);
  // };

  const getAssistantListFunc = async () => {
    setIsLoading(true);
    const result = await dispatch(
      getAssistantList({ text: searchText, customerId })
    );
    setIsLoading(false);
  };

  const debouncedGetAssistantList = useCallback(
    debounce(getAssistantListFunc, 300),
    [searchQuery]
  );

  useEffect(() => {
    debouncedGetAssistantList();
  }, [searchQuery, debouncedGetAssistantList]);

  const AssistantList = useSelector((state) => state.assistants.assistantsList);
  // useEffect(() => {
  //   getAssistantListFunc("");
  // }, []);

  useEffect(() => {
    if (AssistantList) {
      setAssistants(AssistantList.data);
    }
  }, [AssistantList]);

  useEffect(() => {
    dispatch(getAssistantsCount());
  }, []);

  const changeSelection = (newBot) => {
    navigate(
      isMetaAssistant
        ? "/add-meta-assistant"
        : customerId
        ? `/add-assistant/${customerId}`
        : "/add-assistant",
      {
        state: {
          selectedBotId: newBot.id,
          from: "edit",
          planType: isMetaAssistant ? "enterprise" : location?.state?.planType,
          customerName: location?.state?.customerName,
        },
      }
    );
    // setSelectedBot(newBot);
  };

  const duplicateAssistantById = async (assistant) => {
    const isCanCreateAssistant = await onClickCreateAssistant(true);
    if (!isCanCreateAssistant) return;
    setIsLoading(true);
    const result = await dispatch(
      duplicateAssistant({
        assistantId: assistant?.id,
        customerId,
      })
    );
    if (
      duplicateAssistant.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      setSuccessModel(true);
      setSuccessMessage("Assistant Duplicated Successfully!");
      setTimeout(() => {
        setSuccessModel(false);
        getAssistantListFunc();
        dispatch(getAssistantsCount());
      }, 1500);
    } else {
      setIsLoading(false);
      setErrorModel(true);
      setErrorMessage(
        result?.payload?.error?.message ?? result?.payload?.data?.message
      );
      setTimeout(() => {
        setErrorModel(false);
      }, 2000);
    }
  };

  const onDelete = async () => {
    setCOnfirmModel(false);
    setIsLoading(true);
    const result = await dispatch(DeleteAssistant(selectedRow.id));
    setIsLoading(false);
    if (
      DeleteAssistant.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setSuccessMessage("Assistant Deleted Successfully!");
      setSuccessModel(true);
      setTimeout(() => {
        setSuccessModel(false);
        getAssistantListFunc();
        dispatch(getAssistantsCount());
      }, 1500);
    } else {
      //TODO: error popup here

      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const onDeleteClicked = (row) => {
    setselectedRow(row);
    setCOnfirmModel(true);
  };

  return (
    <div className="page__body">
      {assistantPopUp ? <CreateAssistantPopup setPopUp={setPopUp} /> : ""}
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {successModel ? <SuccessModel message={successMessage} /> : ""}
      {buyAdditionalAssistantModal?.visible ? (
        <BuyAdditionalAssistantModal
          onClose={handleCloseBuyAdditionalAssistant}
          type={buyAdditionalAssistantModal.type}
          maxAssistant={buyAdditionalAssistantModal.maxAssistant}
          assistantAmount={buyAdditionalAssistantModal.assistantAmount}
        />
      ) : null}
      {confirmModel ? (
        <ConfirmModel
          onAccept={onDelete}
          onReject={() => {
            setCOnfirmModel(false);
          }}
          title="Delete Assistant!"
          message="Are you sure you want to Delete the Assistant?"
        />
      ) : (
        ""
      )}
      {isLoading ? <Loader /> : ""}

      {(assistants && assistants.length > 0) || searchText?.length ? (
        <React.Fragment>
          <div className="tableWrap__head">
            <div className="formRow m_0  formRow--flexEnd">
              <div className="formCol formCol--flex">
                <div className="formCol flexField">
                  <input
                    className="form__input form__input--search"
                    type="text"
                    placeholder="Search an Assistant"
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value.trimStart());
                    }}
                  />
                </div>
              </div>
            </div>
            {!isMetaAssistant ? (
              <div className="btn__group">
                <button
                  className="btn btn__primary"
                  onClick={()=>onClickCreateAssistant()}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.00008 1.1665V12.8332M1.16675 6.99984H12.8334"
                      stroke="white"
                      stroke-width="1.67"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Create Assistant
                </button>
              </div>
            ) : null}
          </div>
          <div
            className="assistantList"
            style={{ height: assistants?.length ? "auto" : "100%" }}
          >
            {assistants?.length ? (
              assistants.map((assistant) => {
                return (
                  <div className="assistantList__item" key={assistant?.id}>
                    <div className="assistantList__card">
                      {!assistant.avatar ? (
                        <div className="icon icon--bg1">
                          <DefaultChatBot />
                        </div>
                      ) : (
                        <img
                          className="icon icon--bg1"
                          src={assistant.avatar}
                        ></img>
                      )}
                      <div className="infoDetail">
                        <h2 className="title">{assistant.name}</h2>
                        {/* <p className="para">
                        Start to manage you activities with Front Desk
                      </p> */}
                      </div>
                      {!isMetaAssistant ? (
                        <div className="trashAssistantCard">
                          <button
                            className="btn btn__danger btn__outlined"
                            onClick={() => onDeleteClicked(assistant)}
                          >
                            <svg
                              width="13"
                              height="14"
                              viewBox="0 0 13 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0.754883 3.58164H1.93824M1.93824 3.58164H11.4051M1.93824 3.58164V11.7629C1.93824 12.0729 2.06291 12.3701 2.28483 12.5893C2.50676 12.8085 2.80775 12.9316 3.12159 12.9316H9.03837C9.35221 12.9316 9.6532 12.8085 9.87512 12.5893C10.097 12.3701 10.2217 12.0729 10.2217 11.7629V3.58164H1.93824ZM3.71327 3.58164V2.41289C3.71327 2.10292 3.83794 1.80564 4.05987 1.58646C4.28179 1.36728 4.58278 1.24414 4.89662 1.24414H7.26333C7.57718 1.24414 7.87817 1.36728 8.10009 1.58646C8.32201 1.80564 8.44669 2.10292 8.44669 2.41289V3.58164"
                                stroke="#D4001C"
                                stroke-width="1.37775"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                        </div>
                      ) : null}
                      <div className="btn__group">
                        {!isMetaAssistant ? (
                          <button
                            className="btn btn__primary btn__outlined"
                            onClick={() => duplicateAssistantById(assistant)}
                          >
                            Duplicate
                          </button>
                        ) : null}
                        <button
                          className="btn btn__primary"
                          onClick={() => changeSelection(assistant)}
                        >
                          Edit
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="no-data">No Assistant Found!</div>
            )}
          </div>
        </React.Fragment>
      ) : (
        <div className="createAssistant">
          <div className="createAssistant__card">
            <div className="createAssistant__details">
              <h2 className="title">Create Assistant</h2>
              <div className="icon">
                <img src={assistantIcon} alt="" />
              </div>
              <p className="para">
                Assistants are voice AI chat bots used for integrations into
                your applications.You can fully configure them to your
                businesses needs, and we support all major models and providers.
              </p>
              <div className="btn__group">
                <button
                  className="btn btn__primary"
                  onClick={() => onClickCreateAssistant()}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.99984 1.1665V12.8332M1.1665 6.99984H12.8332"
                      stroke="white"
                      stroke-width="1.67"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Create Assistant
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* <div className="createAssistantMain h_100"> */}
      {/* <AssistantsListSidebar changeSelection={changeSelection} /> */}
    </div>
    // </div>
  );
};
